import React from 'react';
import RankTable from './RankTable';
import TeachingRank from './TeachingRank';
import TalentRank from './TalentRank';
import API_URL from '../../../common/url';

function PerformanceRank() {
    return (
        <div className="tabWidth">
            <div className="flexBox">
                <RankTable rankUrl={API_URL.home.queryPerformanceTable} rankName="CRC" toPath="performanceRank" />
                <RankTable rankUrl={API_URL.home.queryPerformanceSsuUserScore} rankName="SSU" toPath="ssuPerformanceRank" />
            </div>
            <div className="flexBox">
                <RankTable rankUrl={API_URL.home.queryPerformancePmUserScore} rankName="PM" toPath="pmPerformanceRank" />
                <RankTable rankUrl={API_URL.home.queryPerformanceSupervisorUserScore} rankName="人员主管" toPath="leaderPerformanceRank" />
            </div>
            <div className="flexBox">
                <TeachingRank />
                <TalentRank />
            </div>
        </div>
    )
}

export default PerformanceRank;


// WEBPACK FOOTER //
// ./src/components/homePage/performanceRank/index.js